// extracted by mini-css-extract-plugin
export default {"container":"FormAddingModelConfig_container__a3T90","containerOpacity":"FormAddingModelConfig_containerOpacity__7IwST"};